import styled from 'styled-components';
import { layout, space } from 'styled-system';

export default styled.h5`
  color: ${props => props.theme.primary};
  font-family: ${props => props.theme.font.primary};
  font-size: ${props => props.theme.font.fontLg};
  font-weight: 500;
  line-height: 24px;
  ${space}
  ${layout}
`;
